import {
  commandCenterIconV1,
  businessCenterIconv1,
  marketingCenterIconv1,
  reportingCenterIconv1,
  workforceCenterIconv1,
  keapMaxIcon,
  enhancedAccessibilityIcon,
  signaturesIcon,
  thryvLeadsIcon,
  seoIcon,
  seoKeywordsIcon,
  seoPowerboostIcon,
  hipaaIcon,
  websiteBuilderIcon,
  cloverAppIcon,
  constantContactIcon,
  copperAppIcon,
  xeroAppIcon,
  googleSheetAppIcon,
  hubspotAppIcon,
  insightlyAppIcon,
  instagramAppIcon,
  jotFormIcon,
  mailchimpIcon,
  myobAppIcon,
  quickbooksAppIcon,
  quickbooksDesktopIcon,
  ringCentralIcon,
  shopifyAppIcon,
  smartDataImporterIcon,
  twillioAppIcon,
  webchatAppIcon,
  facebookMessengerIconApp,
  typeFormIcon,
  growthPackageIcon,
  restrictedAccessIcon,
  gmailLogo,
  reverseOrangePlusIcon,
  reverseGreenPlusIcon,
  logoBuilderIcon,
  customVideoShootIcon,
  listingsAppIcon,
  marketingProEditorIcon,
  professionalServiceIcon,
  socialAdsIcon,
  thryvPayLogov1,
  zapierPromotionIcon,
  ThryvSocialPostsIcon,
  supportV2Icon,
  connectIcon,
  textingIcon,
  phoneMessageIcon,
  profileIcon,
  manageContactsIcon,
  oneHourIcon,
  worldIcon,
  uploadDocumentIcon,
  complianceIcon,
  diyWebsiteIcon,
  videoSupportIcon,
  digitalThryvToolsIcon,
  messagingv2Icon,
  supportCenter,
  keapQuickLaunchIcon,
  listingRefreshIcon,
  strategicContentCreationIcon,
  plusThisIcon,
  thryvGrowthPlatformIcon,
  callTrackingNumberIcon,
  onboardingFeeIcon,
  geoAddOnIcon,
} from '../../../assets'

// Mirrors PLANS_ICONS / getPlanIcon in screens/catalog.js (the live New Order
// and Upgrade Order flows). First matching entry (by substring on the product
// name) wins, same as the original `.filter(...)[0]` lookup. The SEO Keywords
// / SEO PowerBoost entries are hoisted above the generic 'seo' entry so those
// specific add-ons keep their own icon instead of falling back to the
// generic SEO icon that array order alone would otherwise produce.
//
// Shared across every place that renders a product/plan icon (OrderSummary,
// CatalogGrid, ...) so all of them stay in sync with a single source of truth.
const PRODUCT_ICONS = [
  ['my account', commandCenterIconV1],
  ['business center', businessCenterIconv1],
  ['marketing center', marketingCenterIconv1],
  ['reporting center', reportingCenterIconv1],
  ['workforce center', workforceCenterIconv1],
  ['keap max', keapMaxIcon],
  ['keap pro', keapMaxIcon],
  ['keap ultimate', keapMaxIcon],
  ['keap_pro', keapMaxIcon],
  ['keap_ultimate', keapMaxIcon],
  ['keap_max', keapMaxIcon],
  ['hvac', keapMaxIcon],
  ['roofing', keapMaxIcon],
  ['electrical', keapMaxIcon],
  ['plumbing', keapMaxIcon],
  ['insurance', keapMaxIcon],
  ['vertical services', keapMaxIcon],
  ['vertical and mc services', keapMaxIcon],
  ['vertical and mc services & design', keapMaxIcon],
  ['vertical success services', keapMaxIcon],
  ['enhanced accessibility', enhancedAccessibilityIcon],
  ['signatures', signaturesIcon],
  ['seo keywords', seoKeywordsIcon],
  ['seo powerboost', seoPowerboostIcon],
  ['leads', thryvLeadsIcon],
  ['seo', seoIcon],
  ['hipaa', hipaaIcon],
  ['website', websiteBuilderIcon],
  ['clover', cloverAppIcon],
  ['constant contact', constantContactIcon],
  ['copper', copperAppIcon],
  ['xero app', xeroAppIcon],
  ['google sheets', googleSheetAppIcon],
  ['hubspot', hubspotAppIcon],
  ['insightly', insightlyAppIcon],
  ['instagram messenger', instagramAppIcon],
  ['jotform', jotFormIcon],
  ['mailchimp', mailchimpIcon],
  ['myob', myobAppIcon],
  ['quickbooks app', quickbooksAppIcon],
  ['quickbooks desktop', quickbooksDesktopIcon],
  ['ringcentral', ringCentralIcon],
  ['shopify', shopifyAppIcon],
  ['app-smartdataimporter', smartDataImporterIcon],
  ['twilio app', twillioAppIcon],
  ['web chat app', webchatAppIcon],
  ['facebook business messenger app', facebookMessengerIconApp],
  ['typeform app', typeFormIcon],
  ['starter growth package', growthPackageIcon],
  ['expanded growth package', growthPackageIcon],
  ['restricted access', restrictedAccessIcon],
  ['gmail', gmailLogo],
  ['thryv add-ons', reverseOrangePlusIcon],
  ['logo', logoBuilderIcon],
  ['custom video', customVideoShootIcon],
  ['listings management', listingsAppIcon],
  ['marketing pro editor', marketingProEditorIcon],
  ['thryv professional services', professionalServiceIcon],
  ['social ads bronze', socialAdsIcon],
  ['social ads silver', socialAdsIcon],
  ['social ads gold', socialAdsIcon],
  ['social ads bni', socialAdsIcon],
  ['thryvpay', thryvPayLogov1],
  ['zapier', zapierPromotionIcon],
  ['thryv social posts', ThryvSocialPostsIcon],
  ['silver service package', supportV2Icon],
  ['platinum standard service package', supportV2Icon],
  ['platinum premium service package', supportV2Icon],
  ['platinum plus service package', supportV2Icon],
  ['limited e-commerce crm import', connectIcon],
  ['keap text & voice', textingIcon],
  ['keap gmail standard', keapMaxIcon],
  ['keap business line', phoneMessageIcon],
  ['additional user', profileIcon],
  ['additional contacts', manageContactsIcon],
  ['hourly data service', oneHourIcon],
  ['gold service package', supportV2Icon],
  ['e-commerce data transfer', connectIcon],
  ['e-commerce data import', connectIcon],
  ['dedicated ip', worldIcon],
  ['data restore', uploadDocumentIcon],
  ['custom done for you', complianceIcon],
  ['credit card import', connectIcon],
  ['convrrt', diyWebsiteIcon],
  ['basic crm data import', connectIcon],
  ['ask the expert', videoSupportIcon],
  ['api calls - 500k/month', digitalThryvToolsIcon],
  ['advanced data transfer', connectIcon],
  ['advanced crm data import', connectIcon],
  ['500 additional message bundle', messagingv2Icon],
  ['keap add-ons', reverseGreenPlusIcon],
  ['keap', keapMaxIcon],
  ['thryv 24x7 support and service fee', supportCenter],
  ['quick launch', keapQuickLaunchIcon],
  ['starter (monthly)', thryvGrowthPlatformIcon],
  ['signature (monthly)', thryvGrowthPlatformIcon],
  ['premier (monthly)', thryvGrowthPlatformIcon],
  ['starter (annual)', thryvGrowthPlatformIcon],
  ['signature (annual)', thryvGrowthPlatformIcon],
  ['premier (annual)', thryvGrowthPlatformIcon],
  ['listing refresh', listingRefreshIcon],
  ['strategic content creation', strategicContentCreationIcon],
  ['call tracking number', callTrackingNumberIcon],
  ['geo add-on', geoAddOnIcon],
  ['thryv geo expansion', geoAddOnIcon],
  ['kcc certification', keapMaxIcon],
  ['kcp certification', keapMaxIcon],
  ['coach builder', keapMaxIcon],
  ['priority hosting', worldIcon],
  ['priority database', digitalThryvToolsIcon],
  ['graphly', manageContactsIcon],
  ['plusthis', plusThisIcon],
  ['thryv growth platform', thryvGrowthPlatformIcon],
  ['onboarding fee', onboardingFeeIcon],
  ['website design fee', onboardingFeeIcon],
]

export function getProductIcon(productName = '') {
  const name = productName.toLowerCase()
  const match = PRODUCT_ICONS.find(([key]) => name.includes(key))
  const icon = match ? match[1] : reverseOrangePlusIcon
  return icon
}
